const yotpoAppKey = "PP3KZYWq8idNsi8ag7sAYvTSuj1yABjSk7hzSX2d";
const svgIcons = {
  star: `<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 13.0852L3.28889 15.4762C3.18255 15.5302 3.05189 15.4891 2.99706 15.3844C2.97577 15.3438 2.96832 15.2975 2.97581 15.2523L3.83017 10.103L0.064192 6.43136C-0.0208179 6.34848 -0.0214783 6.21346 0.062717 6.12978C0.0954128 6.09728 0.137856 6.07599 0.183781 6.06906L5.4229 5.27766L7.80648 0.617401C7.86029 0.512205 7.99054 0.469862 8.09741 0.522826C8.13891 0.543393 8.17259 0.57655 8.19349 0.617401L10.5771 5.27766L15.8162 6.06906C15.9345 6.08692 16.0156 6.19578 15.9975 6.31219C15.9904 6.3574 15.9688 6.39918 15.9358 6.43136L12.1698 10.103L13.0242 15.2523C13.0434 15.3686 12.9634 15.4782 12.8453 15.4972C12.7994 15.5045 12.7524 15.4972 12.7111 15.4762L7.99998 13.0852Z" fill="#F2C074" /></svg>`,
  starInactive: `<svg class="inactive" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 13.0852L3.28889 15.4762C3.18255 15.5302 3.05189 15.4891 2.99706 15.3844C2.97577 15.3438 2.96832 15.2975 2.97581 15.2523L3.83017 10.103L0.064192 6.43136C-0.0208179 6.34848 -0.0214783 6.21346 0.062717 6.12978C0.0954128 6.09728 0.137856 6.07599 0.183781 6.06906L5.4229 5.27766L7.80648 0.617401C7.86029 0.512205 7.99054 0.469862 8.09741 0.522826C8.13891 0.543393 8.17259 0.57655 8.19349 0.617401L10.5771 5.27766L15.8162 6.06906C15.9345 6.08692 16.0156 6.19578 15.9975 6.31219C15.9904 6.3574 15.9688 6.39918 15.9358 6.43136L12.1698 10.103L13.0242 15.2523C13.0434 15.3686 12.9634 15.4782 12.8453 15.4972C12.7994 15.5045 12.7524 15.4972 12.7111 15.4762L7.99998 13.0852Z" fill="#F4F4F4" /></svg>`,
};

customElements.define(
  "yotpo-stars",
  class YotpoStars extends HTMLElement {
    connectedCallback() {
      this.initYotpo();
    }

    initYotpo() {
      if (!yotpoAppKey) {
        console.error("No Yotpo APP Key configured in theme editor.");
        return;
      }

      fetch(
        `https://api.yotpo.com/products/${yotpoAppKey}/${this.dataset.productId}/bottomline`
      )
        .then((rawFetchResponse) => rawFetchResponse.json())
        .then((data) => {
          const { response, status } = data;

          if (status.code !== 200 || !response) {
            this.style = "display: none;";
            const write = this.parentElement.querySelector(".write-review");
            if (write) {
              write.style = "display: block;";
            }
            return;
          }

          const score = response.bottomline.average_score;
          const totalReviews = response.bottomline.total_reviews;

          if (totalReviews === 0) {
            this.style = "display: none;";
            const write = this.parentElement.querySelector(".write-review");
            if (write) {
              write.style = "display: block;";
            }
            return;
          }

          this.querySelector(".rate").innerHTML = `${score.toFixed(1)}`;
          this.querySelector(".reviews-count").innerHTML = `(${totalReviews})`;
        });
    }
  }
);

customElements.define(
  "yotpo-reviews",
  class YotpoReviews extends HTMLElement {
    connectedCallback() {
      this.page = 1;
      this.reviewsPerPage = 5;
      this.reviews = [];

      if (!yotpoAppKey) {
        console.error("No Yotpo APP Key configured in theme editor.");
        return;
      }

      this.addLoadMoreButtonEvent();
      this.fetchReviews();
    }

    getReviewsUrl() {
      return `https://api-cdn.yotpo.com/v1/widget/${yotpoAppKey}/products/${this.dataset.productId}/reviews.json?per_page=${this.reviewsPerPage}&page=${this.page}`;
    }

    fetchReviews() {
      const options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      const url = this.getReviewsUrl();

      fetch(url, options)
        .then((rawFetchResponse) => rawFetchResponse.json())
        .then((data) => {
          const { response, status } = data;

          console.log(response);

          if (status.code !== 200 || !response) {
            this.style = "display: none;";
            return;
          }

          const { reviews, bottomline } = response;
          this.reviews = [...this.reviews, ...reviews];

          if (this.reviews.length === 0) {
            this.querySelector(".reviews-info").style = "display: none;";
            this.renderLoadMoreButton(bottomline);
            return;
          }

          this.querySelector(".empty-reviews").style = "display: none;";

          this.renderReviewsHeader(bottomline);
          this.renderLoadMoreButton(bottomline);
          this.renderReviews(this.reviews);
        });
    }

    addLoadMoreButtonEvent() {
      this.querySelector(".load-more-button").addEventListener("click", () => {
        this.page = this.page + 1;
        this.fetchReviews();
      });
    }

    renderLoadMoreButton(bottomline) {
      const hasReviewsToLoad =
        this.page * this.reviewsPerPage < bottomline.total_review;
      if (!hasReviewsToLoad) {
        this.querySelector(".load-more-button").style = "display: none;";
        return;
      }
    }

    renderReviewsHeader(bottomline) {
      const score = bottomline.average_score;
      const numOfReviews = bottomline.total_review;

      this.querySelector(".overall__container .description").innerHTML =
        numOfReviews === 1
          ? `${numOfReviews} Review`
          : `${numOfReviews} Reviews`;

      const starSvgs = Array.from(this.querySelectorAll(".stars svg"));

      for (const svgIndex in starSvgs) {
        const svg = starSvgs[+svgIndex];
        if (+svgIndex + 1 > score) {
          svg.outerHTML = svgIcons.starInactive;
        }
      }
    }

    renderReviews(reviews) {
      const reviewElements = Array.from(
        reviews.map((review) => this.getReviewElement(review))
      );
      const target = this.querySelector(".review__container");
      target.innerHTML = "";
      reviewElements.forEach((reviewEl) => {
        const hr = document.createElement("hr");

        target.appendChild(reviewEl);
        target.appendChild(hr);
      });
    }

    getReviewElement(review) {
      if (!review) {
        return null;
      }

      const authorName = review.user.display_name;
      const { score, title, content } = review;
      const MAX_SCORE = 5;

      const innerContainer = document.createElement("div");
      innerContainer.classList.add("review");

      const reviewWrapper = document.createElement("div");
      reviewWrapper.classList.add("review__content");

      const author = document.createElement("div");
      author.classList.add("author");
      author.classList.add("t-body-small");
      author.innerHTML = authorName;
      if (review.verified_buyer) {
        const verified = document.createElement("div");
        verified.classList.add("verified");
        verified.classList.add("t-body-small");
        verified.innerHTML = "Verified";
        author.appendChild(verified);
      }

      const stars = document.createElement("div");
      stars.classList.add("stars");
      const activeStars = [...Array(score).keys()]
        .map(() => svgIcons.star)
        .join("");
      const inactiveStars = [...Array(MAX_SCORE - score).keys()]
        .map(() => svgIcons.starInactive)
        .join("");
      stars.innerHTML = `${activeStars}${inactiveStars}`;
      const reviewTitle = document.createElement("div");
      reviewTitle.classList.add("review-title");
      reviewTitle.classList.add("t-5");
      reviewTitle.innerHTML = title;
      const description = document.createElement("div");
      description.classList.add("description");
      description.innerHTML = content;

      const reviewHeader = document.createElement("div");
      reviewHeader.classList.add("review-header");

      const reviewContent = document.createElement("div");
      reviewContent.classList.add("review-content");

      reviewHeader.appendChild(author);
      reviewHeader.appendChild(stars);
      reviewContent.appendChild(reviewTitle);
      reviewContent.appendChild(description);

      reviewWrapper.appendChild(reviewHeader);
      reviewWrapper.appendChild(reviewContent);

      innerContainer.appendChild(reviewWrapper);

      return innerContainer;
    }
  }
);

customElements.define(
  "yotpo-reviews-modal",
  class YotpoReviewsModal extends HTMLElement {
    connectedCallback() {
      this.querySelector("form").addEventListener("submit", (e) => {
        e.stopPropagation();
        e.preventDefault();
        const formData = new FormData(e.target);
        this.submitReview(formData);
      });
    }

    getSubmitReviewsUrl() {
      return `https://api-cdn.yotpo.com/v1/widget/${yotpoAppKey}/products/${this.dataset.productId}/reviews.json?per_page=${this.reviewsPerPage}&page=${this.page}`;
    }

    submitReview(formData) {
      this.querySelector('button[type="submit"]').setAttribute(
        "disabled",
        true
      );
      // clear form errors
      Array.from(this.querySelectorAll(".error-box")).forEach((el) => {
        el.innerHTML = "";
      });

      const validation = this.validateForm(formData);

      if (!validation.valid) {
        this.handleError(validation);
        this.querySelector('button[type="submit"]').removeAttribute("disabled");
        return;
      }

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          appkey: yotpoAppKey,
          domain: "jellydevelopment.myshopify.com",
          sku: this.dataset.productId,
          product_title: this.dataset.productTitle,
          product_url: this.dataset.productUrl,
          display_name: formData.get("name"),
          email: formData.get("email"),
          review_content: formData.get("review"),
          review_title: formData.get("title"),
          review_score: +formData.get("rating"),
        }),
      };

      fetch("https://api.yotpo.com/v1/widget/reviews", options)
        .then((rawRes) => rawRes.json())
        .then(() => {
          this.querySelector('button[type="submit"]').removeAttribute(
            "disabled"
          );
          this.handleSuccess();
        })
        .catch((err) => {
          this.handleError({
            message: "Something went wrong. Please try again later.",
          });
          this.querySelector('button[type="submit"]').removeAttribute(
            "disabled"
          );
        });
    }

    validateForm(formData) {
      const dataToValidate = {
        display_name: formData.get("name"),
        email: formData.get("email"),
        review_content: formData.get("review"),
        review_title: formData.get("title"),
        review_score: +formData.get("rating"),
      };

      const errors = [];

      if (!dataToValidate.display_name) {
        errors.push({ field: "name", message: "Name is required." });
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!dataToValidate.email) {
        errors.push({ field: "email", message: "Email is required." });
      } else if (!emailRegex.test(dataToValidate.email)) {
        errors.push({ field: "email", message: "Email is invalid." });
      }

      if (!dataToValidate.review_content) {
        errors.push({ field: "review", message: "Review is required." });
      }

      if (!dataToValidate.review_title) {
        errors.push({ field: "title", message: "Title is required." });
      }

      if (!dataToValidate.review_score) {
        errors.push({ field: "rating", message: "Rating is required." });
      }

      if (errors.length > 0) {
        return { valid: false, errors, message: "Form is invalid." };
      }

      return { valid: true };
    }

    handleSuccess() {
      this.querySelector(".modal-title").innerHTML = "Thank you!";
      this.querySelector(".modal-content").innerHTML =
        "Your review was submitted. Please confirm your email to publish it.";
      this.querySelector(".modal-content").setAttribute(
        "class",
        "pt-16 text-center"
      );
    }

    handleError(validation) {
      console.log(validation.message);

      if (validation.errors && validation.errors.length > 0) {
        for (const error of validation.errors) {
          const item = this.querySelector(`[data-error-name="${error.field}"]`);
          item.innerHTML = error.message;
        }
      }
    }

    toggle() {
      this.querySelector(".modal-wrapper").classList.toggle("hidden");
    }
  }
);
